<template lang="html">
  <modal name="permission-modal" height="auto" width="416" :adaptive="true" :maxWidth="416" class="permission-modal">
    <div class="modal-container">
      <div class="modal-header bold black">
      What are permissions?
    </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        <div>Permissions allow account administrators to decide what features and information a user has access to. The available permissions are:</div>

        <div class="gap-3x" />
        <div class="bold">Administrator</div>
        <div>Administrator permissions control access to an organization. They can see what users are part of their organization, add users, remove users, and change permissions. They also have access to billing. There can only be one administrator per organization.</div>

        <div class="gap-3x" />
        <div class="bold">Basic</div>
        <div>Basic permissions allow a user to access {{productName}} using one of the organization's available software licenses. They can also see who is a part of their organization.</div>
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer">
      <SymbiumButton
        kclass="btn-base"
        :isSmall="true"
        text="Close"
        :onClick="close"
      />
    </div>
    </div>
  </modal>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  components: { SymbiumButton },
  props: ['productName'],
  methods: {
    close() {
      this.$modal.hide('permission-modal');
    }
  }
}
</script>

<style lang="scss">
.permission-modal {
  .modal-body {
    overflow: scroll;
    height: 280px;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 0px;  /* Remove scrollbar space */
      background: transparent;  /* Optional: just make scrollbar invisible */
    }
    /* Optional: show position indicator in red */
    &::-webkit-scrollbar-thumb {
        background: #FF0000;
    }
  }

  .modal-footer .oval-button {
    padding: 8px 16px;
    margin: 0;

    .text {
      line-height: 14px;
    }
  }
}
</style>
